// extracted by mini-css-extract-plugin
export default {"alertModal":"WorkpackAlertModal_alertModal__Kvywv","alertButton":"WorkpackAlertModal_alertButton__zWzYC"};